// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/tailwind","css/admin-login","css/global"], () => (__webpack_require__("./js/main.js")))
__webpack_require__.O(undefined, ["css/tailwind","css/admin-login","css/global"], () => (__webpack_require__("./scss/global.scss")))
__webpack_require__.O(undefined, ["css/tailwind","css/admin-login","css/global"], () => (__webpack_require__("./scss/admin-login.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/tailwind","css/admin-login","css/global"], () => (__webpack_require__("./tailwind.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
